export default __webpack_public_path__ + "static/media/CNo.68-7.f3626220.jpg";